// eslint-disable-next-line filenames/match-exported
import { CgWebsite } from "react-icons/cg";
import { LiaKeySolid } from "react-icons/lia";
import { RiGitRepositoryLine } from "react-icons/ri";
import { TbCloudCog } from "react-icons/tb";
import { VscGistSecret } from "react-icons/vsc";

import { ComponentWithAs, IconProps } from "@chakra-ui/react";

import {
  BuildSettingsIcon,
  ChartIcon,
  ClusterIcon,
  DatasetsIcon,
  EnvHandlesIcon,
} from "@/components/shared/ReleaseIcons";

export const configurationMenuItems = [
  "Cloud",
  {
    label: "Cloud Integrations",
    icon: TbCloudCog as ComponentWithAs<"svg", IconProps>,
    slug: "cloud_integrations",
  },
  { label: "Clusters", icon: ClusterIcon, slug: "clusters" },
  { label: "Domains", icon: CgWebsite as ComponentWithAs<"svg", IconProps>, slug: "domains" },
  "Build",
  { label: "Build Arguments", icon: BuildSettingsIcon, slug: "build_arguments" },
  { label: "SSH Keys", icon: LiaKeySolid as ComponentWithAs<"svg", IconProps>, slug: "ssh_keys" },
  {
    label: "External Registries",
    icon: RiGitRepositoryLine as ComponentWithAs<"svg", IconProps>,
    slug: "external_registries",
  },
  "Deploy",
  { label: "Datasets", icon: DatasetsIcon, slug: "datasets" },
  { label: "Environment Presets", icon: EnvHandlesIcon, slug: "environment_presets" },
  "Other",
  { label: "Secrets", icon: VscGistSecret as ComponentWithAs<"svg", IconProps>, slug: "secrets/release" },
  { label: "Integrations", icon: ChartIcon, slug: "integrations" },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type ConfigurationMenuItem = ExtractSlug<(typeof configurationMenuItems)[number]>;
